var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_EditNodeAlertRules"),
        width: "760px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view warn-rule-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  { staticClass: "section form-column content-wrapper" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_WarningSwitch")
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.open,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "open", $$v)
                                  },
                                  expression: "form.open"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_StartAlert"))
                                  )
                                ]),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_CloseAlert"))
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_WarningConditions")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "default-value": _vm.form.warningDateField,
                                "static-options": _vm.alertTypes,
                                "tag-value": "code",
                                cache: false,
                                filterable: "",
                                "filter-type": "global"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.warningDateField = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showNodeStatus,
                                expression: "showNodeStatus"
                              }
                            ],
                            attrs: { label: _vm.$t("Sop.SelectTheNode") }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                "default-value":
                                  _vm.form.triggerTrackingDetailUuid,
                                "static-options": _vm.completeNodeStatus,
                                cache: false,
                                filterable: "",
                                "filter-type": "global",
                                "tag-value": "trackingDetailUuid",
                                "custom-label": function(item) {
                                  return (
                                    item.codeCname +
                                    "(" +
                                    item.subCodeCname +
                                    ")"
                                  )
                                }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.triggerTrackingDetailUuid = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_WarningContent")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "240px" },
                              model: {
                                value: _vm.form.content,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "content", $$v)
                                },
                                expression: "form.content"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AutoIgnoreMode")
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.ignoreType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ignoreType", $$v)
                                  },
                                  expression: "form.ignoreType"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_EarlyTimedIgnore")
                                    )
                                  )
                                ]),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_TurnOffAutoIgnore")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_IgnoreTime")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "120px !important" },
                                  attrs: {
                                    disabled: _vm.form.ignoreType === 0,
                                    type: "number",
                                    oninput: "value=value.replace(/[^\\d]/g,'')"
                                  },
                                  model: {
                                    value: _vm.form.ignoreTime,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "ignoreTime", $$v)
                                    },
                                    expression: "form.ignoreTime"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "5px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_AutomaticallyIgnoreAfterHours"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RemarksInfo")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.form.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column content-wrapper",
                    staticStyle: {
                      "margin-left": "0px",
                      "margin-top": "0px",
                      "flex-grow": "1"
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_SetSOPNodeOfAlert"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SopTemplate")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.templateName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "templateName", $$v)
                                },
                                expression: "form.templateName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_SopNode") }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.trackingName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "trackingName", $$v)
                                },
                                expression: "form.trackingName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Sop.nodeState") } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.trackingDetailName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "trackingDetailName", $$v)
                                },
                                expression: "form.trackingDetailName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_ApplicationScope")
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: {
                                  disabled: !!_vm.form.triggerTrackingDetailUuid
                                },
                                model: {
                                  value: _vm.ignoreMode,
                                  callback: function($$v) {
                                    _vm.ignoreMode = $$v
                                  },
                                  expression: "ignoreMode"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-bottom": "5px" },
                                    attrs: { label: true }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ApplyToAllTemplates"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-radio", { attrs: { label: false } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_UseOnlyTheCurrentTemplate"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DocumentNotification"
                              )
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.notifyJobType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "notifyJobType", $$v)
                                  },
                                  expression: "form.notifyJobType"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-bottom": "5px" },
                                    attrs: { label: 0 }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_NoticeOfEachBill"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_NoNoticeOfTickets")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section form-column content-wrapper" },
              [
                _c(
                  "el-scrollbar",
                  { staticStyle: { height: "60vh" } },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SopTimeSetUp"))
                          )
                        ]),
                        _vm._l(_vm.warningRuleItemList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              style: {
                                marginTop: index > 0 ? "20px" : "",
                                paddingLeft: "20px"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "5px",
                                    "margin-left": "-25px"
                                  }
                                },
                                [
                                  index + 1 ===
                                    _vm.warningRuleItemList.length &&
                                  _vm.warningRuleItemList.length !== 3
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "form-operator",
                                          on: {
                                            click: function($event) {
                                              return _vm.onAdd()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-circle-plus"
                                          })
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "form-operator",
                                          on: {
                                            click: function($event) {
                                              return _vm.onRemove(item, index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-remove"
                                          })
                                        ]
                                      ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "100px",
                                        "margin-right": "5px"
                                      },
                                      model: {
                                        value: item.ruleItem,
                                        callback: function($$v) {
                                          _vm.$set(item, "ruleItem", $$v)
                                        },
                                        expression: "item.ruleItem"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          value: "1",
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_BringForward"
                                          )
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          value: "2",
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Postpone"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "50px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      type: "number",
                                      oninput:
                                        "value=value.replace(/[^\\d]/g,'')"
                                    },
                                    model: {
                                      value: item.duration,
                                      callback: function($$v) {
                                        _vm.$set(item, "duration", $$v)
                                      },
                                      expression: "item.duration"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Pricing.Hour")))
                                  ]),
                                  _c("el-input-number", {
                                    staticStyle: {
                                      width: "50px",
                                      "margin-left": "5px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      type: "number",
                                      min: 0,
                                      max: 59,
                                      step: 1,
                                      controls: false
                                    },
                                    model: {
                                      value: item.minute,
                                      callback: function($$v) {
                                        _vm.$set(item, "minute", $$v)
                                      },
                                      expression: "item.minute"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_EarlyWarningReminder"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_WarningLevel")
                                  }
                                },
                                _vm._l(_vm.levels, function(item2) {
                                  return _c(
                                    "el-radio-group",
                                    {
                                      key: item2.code,
                                      model: {
                                        value: item.level,
                                        callback: function($$v) {
                                          _vm.$set(item, "level", $$v)
                                        },
                                        expression: "item.level"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "10px"
                                          },
                                          attrs: { label: item2.code }
                                        },
                                        [_vm._v(_vm._s(item2.chineseName))]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _c("span", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_SetAlertNotificationObject"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "div",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: function($event) {
                                              item.notifierRoles = ""
                                            }
                                          },
                                          model: {
                                            value: item._ext.hasDesignatedPost,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item._ext,
                                                "hasDesignatedPost",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item._ext.hasDesignatedPost"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DesignatedPost"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      attrs: {
                                        value: _vm.toArray(item.notifierRoles),
                                        disabled: !item._ext.hasDesignatedPost
                                      },
                                      on: {
                                        input: function(val) {
                                          item.notifierRoles = _vm.toTxt(val)
                                        }
                                      }
                                    },
                                    _vm._l(_vm.roles, function(item, index) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: index,
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: { label: item.code }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isZh
                                                ? item.chineseName
                                                : item.englishName
                                            )
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: function($event) {
                                              item.notifierIds = ""
                                            }
                                          },
                                          model: {
                                            value: item._ext.hasNotifierIds,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item._ext,
                                                "hasNotifierIds",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item._ext.hasNotifierIds"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_DesignatedPersonnel"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("cargo-advance-select", {
                                        staticStyle: {
                                          width: "205px",
                                          "margin-top": "10px"
                                        },
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames.basic_data_User,
                                          fields: ["chineseName"],
                                          disabled: !item._ext.hasNotifierIds,
                                          "callback-params": {
                                            key: "userList"
                                          },
                                          "callback-method-type": "value",
                                          "tag-value": "userId",
                                          "tag-name": "chineseName",
                                          "filter-tag-names": ["chineseName"],
                                          "method-params": {
                                            pageSize: 1000000,
                                            active: true,
                                            hasRole: true
                                          },
                                          "default-multiple-value": _vm.toArray(
                                            item.notifierIds
                                          ),
                                          multiple: "",
                                          filterable: "",
                                          "options-width": "230px"
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            item.notifierIds = _vm.toTxt(
                                              p.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: { value: !!item.enableMail },
                                          on: {
                                            input: function(val) {
                                              item.enableMail = val ? 1 : 0
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: { value: !!item.enableWeChat },
                                          on: {
                                            input: function(val) {
                                              item.enableWeChat = val ? 1 : 0
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Wechat")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.commitHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c("el-button", { on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }